import { FC } from 'react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../../../components/ui/select'

import { useAppSelector } from '../../../../../../store/hooks'
import {
  selectRegistration,
  selectTeamTabData,
} from '../../../../../../store/registration/registrationSlice'
import { Switch } from '../../../../../../components/ui/switch'
import { cn } from '../../../../../../lib/utils'

interface SelectedEventPriceProps {
  price: string
  isQualify?: boolean | null
  qualifyFee?: string
  qualifyFeeName?: string | null
  isSplitBill: boolean
  showAssignTo?: boolean
  recipientId: string | null
  ownerId: string | null
  onAssignChange?: (id: string) => Promise<void>
  onRecipientChange?: (state: boolean) => Promise<void>
}
export const SelectedEventPrice: FC<SelectedEventPriceProps> = ({
  price,
  isQualify,
  qualifyFee,
  qualifyFeeName,
  isSplitBill,
  showAssignTo,
  ownerId,
  onAssignChange,
  recipientId,
  onRecipientChange,
}) => {
  const teamTabData = useAppSelector(selectTeamTabData)
  const registration = useAppSelector(selectRegistration)

  const selectedOwner = ownerId?.trim() ? ownerId : undefined

  const isDisabledBill = !selectedOwner || ownerId === registration?.userId

  return (
    <div className="flex flex-wrap gap-4 items-center justify-end ml-auto max-w-full">
      {(showAssignTo || isSplitBill) && (
        <Select disabled={!showAssignTo} value={selectedOwner} onValueChange={onAssignChange}>
          <SelectTrigger className="min-w-48 max-w-full disabled:bg-input truncate ellipsis">
            <SelectValue placeholder="Assign to..." />
          </SelectTrigger>
          <SelectContent>
            {teamTabData?.map(
              (member) =>
                member.memberId && (
                  <SelectItem key={member.memberId} value={member.memberId}>
                    {member.memberName}
                  </SelectItem>
                )
            )}
          </SelectContent>
        </Select>
      )}
      {isSplitBill && (
        <label
          className={cn(
            'flex items-center space-x-2',
            isDisabledBill && 'pointer-events-none opacity-70'
          )}
        >
          <Switch
            disabled={isDisabledBill}
            checked={ownerId === registration?.userId ? true : recipientId === ownerId}
            onCheckedChange={onRecipientChange}
          />
          <span className="text-sm text-gray-600">Send bill</span>
        </label>
      )}
      <p className="font-semibold text-gray-900 text-right w-[140px]">
        {price}
        {isQualify && (
          <>
            {' '}
            • {qualifyFee}{' '}
            <span className="font-normal text-sm text-black/50">{qualifyFeeName || 'qual'}</span>
          </>
        )}
      </p>
    </div>
  )
}
